<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">
        Admin
    </h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            <a routerLink="/dashboard" class="d-inline-block position-relative">
                <i class="ri-home-8-line"></i>
                Dashboard
            </a>
        </li>
        <li class="breadcrumb-item position-relative">
            Settings
        </li>
        <li class="breadcrumb-item position-relative">
            API APPS
        </li>
    </ol>
</div>

<mat-card class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()">
    <mat-card-content>
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab label="API APPS">
                <mat-card class="scroll-container" style="padding: 2rem;">
                    <mat-card-header>
                        <mat-card-title>
                            <div class="search-box position-relative">
                                <i class="material-symbols-outlined search-icon">search</i>
                                <input type="text" class="input-search d-block w-100 border-none outline-0"
                                    placeholder="Search here..." [(ngModel)]="searchDivisionValue"
                                    (keydown.enter)="getData(1)">
                                <i *ngIf="searchDivisionValue" class="material-symbols-outlined cross-icon"
                                    (click)="resetApiSettingsSearch()">
                                    close
                                </i>
                            </div>

                        </mat-card-title>

                        <mat-card-subtitle>
                            <div class="d-flex justify-content-end">
                                <button type="button" mat-flat-button class="daxa card-header-menu-btn button-gap"
                                    (click)="refresh()">Refresh</button>
                                <a (click)="newApiSettings()" type="button" mat-flat-button
                                    class="daxa card-header-menu-btn" style="text-wrap: nowrap;">Add New</a>
                            </div>
                        </mat-card-subtitle>

                    </mat-card-header>

                    <mat-card-content>
                        <div class="recent-orders-table">
                            <ng-container *ngIf="paginatedData?.totalItems > 0; else noMachines">
                                <div class="table-responsive">
                                    <table mat-table [dataSource]="apiSettingsDataSource">
                                        <ng-container matColumnDef="id">
                                            <th mat-header-cell *matHeaderCellDef>ID</th>
                                            <td mat-cell *matCellDef="let element"
                                                (contextmenu)="onDivisionRightClick($event, element)">
                                                {{element.id}}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="api_type_name">
                                            <th mat-header-cell *matHeaderCellDef>API App</th>
                                            <td mat-cell *matCellDef="let element"
                                                (contextmenu)="onDivisionRightClick($event, element.id)">
                                                {{element.api_type_name}}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="is_connected">
                                            <th mat-header-cell *matHeaderCellDef>Connected?</th>
                                            <td mat-cell *matCellDef="let element"
                                                (contextmenu)="onDivisionRightClick($event, element.id)">
                                                <mat-checkbox [checked]="element.is_connected" disabled></mat-checkbox>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="connection_checked_at">
                                            <th mat-header-cell *matHeaderCellDef>Connection verified at</th>
                                            <td mat-cell *matCellDef="let element"
                                                (contextmenu)="onDivisionRightClick($event, element.id)">
                                                {{element.connection_checked_at | date:'dd/MM/yyyy hh:mm a'}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="created_by">
                                            <th mat-header-cell *matHeaderCellDef>Created By</th>
                                            <td mat-cell *matCellDef="let element"
                                                (contextmenu)="onDivisionRightClick($event, element.id)">
                                                {{element.created_by}}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="modified_by">
                                            <th mat-header-cell *matHeaderCellDef>Modified By</th>
                                            <td mat-cell *matCellDef="let element"
                                                (contextmenu)="onDivisionRightClick($event, element.id)">
                                                {{element.updated_by}}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="actions">
                                            <th mat-header-cell *matHeaderCellDef>
                                                Action
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <div class="action-info">
                                                    <button type="button" mat-button matTooltip="Edit Division"
                                                        matTooltipPosition="above" (click)="editAPISettings(element.id)">
                                                        <i class="material-symbols-outlined edit-icon-color">
                                                            Edit
                                                        </i>
                                                    </button>
                                                </div>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="apiDisplayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: apiDisplayedColumns;"></tr>
                                    </table>

                                    <div [ngClass]="{ 'dark-context-menu': isDarkTheme }" class="context-menu"
                                        [ngStyle]="{ top: contextDivisionMenuY + 'px', left: contextDivisionMenuX + 'px' }"
                                        *ngIf="contextDivisionMenuVisible">
                                        <button mat-menu-item (click)="editAPISettings(selectedDivisionElement)">
                                            <i class="material-symbols-outlined">edit</i> Edit
                                        </button>
                                    </div>
                                </div>

                                <div class="custom-paginator">
                                    <button mat-icon-button (click)="goToApiSettingsPage(paginatedData.previousPage)"
                                        [disabled]="!paginatedData.canViewPreviousPage">
                                        <mat-icon>chevron_left</mat-icon>
                                    </button>

                                    <span class="paginator-text">
                                        Showing {{startDivisionItem}}-{{endDivisionItem}} of {{totalItems}}
                                        items
                                        <span *ngIf="totalItems === 0">(No items)</span>
                                    </span>

                                    <button mat-icon-button (click)="goToApiSettingsPage(paginatedData.nextPage)"
                                        [disabled]="!paginatedData.canViewNextPage">
                                        <mat-icon>chevron_right</mat-icon>
                                    </button>
                                </div>
                            </ng-container>
                            <ng-template #noMachines>
                                <hr>
                                <div class="no-data-found text-center">
                                    <h5>No Data Found</h5>
                                </div>
                                <hr>
                            </ng-template>
                        </div>
                    </mat-card-content>
                </mat-card>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</mat-card>

<!-- Loader Overlay -->
<div *ngIf="loading" class="export-overlay">
    <div class="spinner"></div>
</div>